(function () {
  'use strict';

  var PROMO_BUTTON = '.cart-promo-box-button';
  var PROMO_ITEM = '.cart-promo-box-item';
  var PROMO_SCOPES = ['#header-mini-cart-footer', '#cart-page-cart-promo-box', '#main-cart-footer'];

  var observers = [];
  var marking = false;
  var refreshTimer = null;

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function resolveCouponHost(button) {
    var insideCartCoupon = button.closest('cart-coupon');
    if (insideCartCoupon) return insideCartCoupon;

    if (button.closest('#cart-page-cart-promo-box')) {
      return document.querySelector('cart-coupon:not(.is-mini-cart)');
    }

    return null;
  }

  function fetchDiscountCodes() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        return Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      })
      .catch(function () {
        return null;
      });
  }

  function paint(codes) {
    var applicable = {};

    codes.forEach(function (discount) {
      if (discount && discount.applicable === true && discount.code) {
        applicable[String(discount.code).toUpperCase()] = true;
      }
    });

    document.querySelectorAll(PROMO_BUTTON).forEach(function (button) {
      var code = (button.dataset.code || '').toUpperCase();
      var isApplied = code !== '' && applicable[code] === true;

      button.classList.toggle('applied', isApplied);
      button.disabled = isApplied;

      var label = isApplied ? 'Applied' : 'Use Code';
      if (button.textContent.trim() !== label) button.textContent = label;
    });
  }

  function refreshAppliedState() {
    if (marking) return;

    marking = true;

    fetchDiscountCodes()
      .then(function (codes) {
        if (codes) paint(codes);
      })
      .finally(function () {
        marking = false;
      });
  }

  var scheduleRefresh = debounce(function () {
    if (marking) return;
    refreshAppliedState();
  }, 150);

  function onPromoClick(event) {
    var button = event.target.closest(PROMO_BUTTON);
    if (!button) {
      var item = event.target.closest(PROMO_ITEM);
      button = item && item.querySelector(PROMO_BUTTON);
    }
    if (!button || button.disabled) return;

    event.preventDefault();

    var code = (button.dataset.code || '').trim();
    if (!code) {
      console.warn('[cart-promo-box] 这一行没有配置折扣码，已跳过。');
      return;
    }

    var host = resolveCouponHost(button);
    if (!host || !host.input) {
      console.warn('[cart-promo-box] 没有找到可用的 coupon 输入框。');
      return;
    }

    Promise.resolve(host.submit(event, code))
      .then(refreshAppliedState)
      .catch(refreshAppliedState);
  }

  function observeScopes() {
    PROMO_SCOPES.forEach(function (selector) {
      var element = document.querySelector(selector);

      if (!element || element.dataset.promoObserved === '1') return;
      element.dataset.promoObserved = '1';

      var observer = new MutationObserver(scheduleRefresh);
      observer.observe(element, { childList: true, subtree: true });
      observers.push(observer);
    });
  }

  function init() {
    document.addEventListener('click', onPromoClick);
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.button-cart-coupon')) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshAppliedState, 700);
    });

    observeScopes();

    if (document.querySelector(PROMO_BUTTON)) refreshAppliedState();

    ['cart:item-add', 'cart:item-remove', 'cart:item-quantity-update'].forEach(function (name) {
      if (typeof subscribe === 'function') {
        subscribe(name, debounce(observeScopes, 300));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
